import { UrlServerBase } from "@/shared/logic/controller";

const basePath = "/inscription";

export function parsePreselected() {
  const chunks = window.location.pathname.split("/");
  const preselected = chunks[chunks.length - 1];
  if (isNaN(Number(preselected))) {
    // pas de préselection
    return "";
  }
  return preselected;
}

/** prend en compte le mode dev et les query params */
export function apiUrl(endpoint: string) {
  const loc = window.location;
  const out = UrlServerBase + basePath + endpoint + loc.search + loc.hash;
  return out;
}
